import { createWebHistory, createRouter } from "vue-router";
import Home from "@/views/Home.vue";
import Login from "@/views/Login.vue";
import Profiles from "@/views/Profiles.vue";
import WaterPoints from "@/views/WaterPoints.vue";
import Sensors from "@/views/Sensors.vue";
import Info from "@/views/Info.vue";

const routes = [
  {
    path: "/",
    name: "home",
    component: Home
  },
  {
    path: "/level",
    name: "level",
    component: Home
  },
  {
    path: "/withdrawal",
    name: "withdrawal",
    component: Home
  },
  {
    path: "/precipitation",
    name: "precipitation",
    component: Home
  },
  {
    path: "/login",
    name: "login",
    component: Login
  },
  {
    path: "/profiles",
    name: "profiles",
    component: Profiles
  },
  {
    path: "/waterpoints",
    name: "waterPoints",
    component: WaterPoints
  },
  {
    path: "/sensors",
    name: "sensors",
    component: Sensors,
	//beforeEach: persistentParams(['next_to'])
	props: true
  },
  {
    path: "/info",
    name: "Info",
    component: Info
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

function persistentParams(params) {
	
	return function(to, from) {
		
		if (to.path === from.path) {
			return false; // This is a no-no via the documentation, but a bug in routing to identical routes
		}
		
		return params.reduce( function(accumulator, param) {
			if (from.query[param] && !to.query[param]) {
				accumulator.query[param] = from.query[param];
			}
		}, {path: to.path, query: {}});
	};
}

export default router;